import React from 'react'
import { getImages } from '../Components/const'
import UseScrollReveal from '../Components/Common/UseScrollReveal '
import SeoMeta from '../Components/Common/SeoMeta'

const RoadsideAssistance = () => {
    UseScrollReveal()
    return (
        <>
            <SeoMeta
                title="Roadside Assistance | New & Used McLaren For Sale | McLaren Orlando"
                description="Enjoy continued peace of mind with McLaren Roadside Assistance. For more information, call McLaren Orlando today! (407) 988-0111"
                keywords=""
                ogTitle="Roadside Assistance | New & Used McLaren For Sale | McLaren Orlando"
                ogDescription="Enjoy continued peace of mind with McLaren Roadside Assistance. For more information, call McLaren Orlando today! (407) 988-0111"
            />
            <section className='common-banner-wrap'>
                <img src={getImages('roadside-assistance-bg.webp')} alt='roadside assistance banner' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando</h4>
                                <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Roadside Assistance</h1>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <a href='tel:8554625273' className='theme-btn text-uppercase d-inline-block'>855-462-5273</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='common-wrap'>
                <div className='container'>
                    <h2 className='lg-title text-gray fw-300 text-uppercase mb-3 wow reveal fadeInUp'>Enjoy continued peace of mind</h2>
                    <h3 className='xs-title fw-bold text-orange text-uppercase mb-2 wow reveal fadeInUp'>Call McLaren Roadside Assistance</h3>
                    <div className='xs-title text-gray font-1-9em text-uppercase mb-3 wow reveal fadeInUp'>855-462-5273</div>
                    <div className='common-text mb-5 wow reveal fadeInUp'>
                        <p>McLaren vehicles are engineered and built to the highest standards and are tested exhaustively in a variety of conditions, but for those moments when it may be necessary there is McLaren Roadside Assistance*.</p>

                        <p>One phone call to the customer assistance center and you can rest assured that you and your vehicle will be taken care of through McLaren’s network of specialists or an approved partner. If necessary, Roadside will deliver your car to your nearest McLaren dealer for fast and efficient service.</p>
                    </div>
                    <div className='xs-title font-0-9em fw-300 text-dgray pt-5'>
                        *Terms and conditions apply. Contact us for full details.<br />
                        **Market exclusions and exceptions apply, please contact McLaren Orlando for further information
                    </div>
                </div>
            </section>
            <section className='call-anytime-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <img className='wow reveal fadeInUp' src={getImages('call-anytime-image1.webp')} alt='call anytime' />
                            <img className='mt-5 wow reveal fadeInUp' src={getImages('call-anytime-image2.webp')} alt='call anytime' />
                        </div>
                        <div className='col-md-6'>
                            <h3 className='xs-title fw-bold text-orange text-uppercase mb-2 wow reveal fadeInUp'>Call Us Anytime</h3>
                            <h2 className='lg-title text-white text-uppercase mb-2 wow reveal fadeInUp'>Roadside Assistance</h2>
                            <div className='xs-title fw-300 font-1-1em mb-4 text-lgray text-uppercase wow reveal fadeInUp'>Please have the following information ready</div>
                            <ul className='ca-info-list wow reveal fadeInUp'>
                                <li>Vehicle Identification Number (VIN)</li>
                                <li>Brief description of the problem</li>
                                <li>Current vehicle location</li>
                                <li>Your current location</li>
                                <li>Best phone number for you to be contacted</li>
                            </ul>
                            <div className='mt-5 wow reveal fadeInUp'>
                                <a href='tel:8554625273' className='sub-sm-btn d-inline-block w-240'>855-462-5273</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default RoadsideAssistance